/**
 * redline-gallery — clickable multi-image gallery component
 * Shows one image at a time. Wires up [data-gallery-prev]/[data-gallery-next]
 * buttons if present (only [data-gallery-next] is required); clicking
 * anywhere else on the gallery, or pressing arrow keys, also navigates.
 */
class RedlineGallery extends HTMLElement {
  connectedCallback() {
    this._imgs = Array.from(this.querySelectorAll('[data-gallery-img]'));
    this._counter = this.querySelector('[data-gallery-counter]');
    this._current = 0;

    if (this._imgs.length === 0) return;

    this._update();

    const prev = this.querySelector('[data-gallery-prev]');
    const next = this.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', (e) => {
      e.stopPropagation();
      this._go(-1);
    });
    if (next) next.addEventListener('click', (e) => {
      e.stopPropagation();
      this._go(1);
    });

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-gallery-prev], [data-gallery-next]')) return;
      this._go(1);
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === ' ' || e.key === 'Enter') this._go(1);
      if (e.key === 'ArrowLeft') this._go(-1);
    });

    this.setAttribute('tabindex', '0');
  }

  _go(dir = 1) {
    const len = this._imgs.length;
    this._current = ((this._current + dir) % len + len) % len;
    this._update();
  }

  _update() {
    this._imgs.forEach((img, i) => {
      img.classList.toggle('is-active', i === this._current);
    });
    if (this._counter) {
      this._counter.textContent = `${this._current + 1}/${this._imgs.length}`;
    }
  }
}

customElements.define('redline-gallery', RedlineGallery);
